import Skeleton from 'react-loading-skeleton'

export default function LoadingSkeleton({height, count}){
  return <Skeleton height={height} count={count} />
}
